<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('client.breadcrumbTypo')"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="$t('client.editBreadcrumb')"
      :title="$t('client.editTitle')"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :placeholder="'name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>

          <div class="input-container">
            <MainCheckbox :label="'Active'" :id="'is_active'" :set-value="formDataToSend" />
          </div>
          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>

        <div v-if="data" class="list-items">
          <div class="list-items__title">Client Integrations</div>
          <div v-for="int in data.integrations" :key="int.id" class="item">
            <div class="item-col">{{ int.name }}</div>
            <div class="item-col">{{ int.isActive ? "active" : "no active" }}</div>
            <div class="item-col">Capacity: {{ int.sendCapacity }}</div>
            <div class="item-col">
              <span v-for="(country, index) in int.countries" :key="country.id">
                <template v-if="index == 0">{{ getNameCountry(country.countryId) }}</template>
                <template v-else>, {{ getNameCountry(country.countryId) }}</template>
              </span>
            </div>
            <div class="item-col">
              <template v-if="int.sendWorkTime.all">
                <b>All</b>: {{ int.sendWorkTime.all }}
              </template>
              <template v-if="int.sendWorkTime.days">
                <div v-for="(day, index) in Object.keys(int.sendWorkTime.days)" :key="index">
                  <b>{{ day }}</b
                  >: {{ int.sendWorkTime.days[day] }}
                </div>
              </template>
            </div>
            <div class="item-col">
              <div @click="handleEditInt(int.id)" class="item-button">Edit</div>
            </div>
          </div>
        </div>

        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";

export default {
  name: "ClientCreate",
  metaInfo: {
    title: "Client Create",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
        is_active: true,
      },
      data: null,
      countryList: [],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    MainCheckbox,
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess", "validationErrors"]),
    getFirstLink() {
      return ROUTE.CLIENT_LIST.replace(":page", 1);
    },
    getId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.getItem();
    this.getCountry();
  },
  methods: {
    handleSubmit() {
      const data = {
        name: this.formDataToSend.name,
        is_active: this.formDataToSend.is_active,
      };

      const url = `/${this.getId}`;

      this.$store.dispatch("lead/editClient", { url: url, editData: data });
    },
    getNameCountry(id) {
      return this.countryList.find((country) => {
        return country.id == id;
      }).enName;
    },
    async getCountry() {
      await leadApi
        .getCountryList()
        .then((res) => {
          this.countryList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.CLIENT_LIST.replace(":page", 1),
      });
    },
    getItem() {
      const url = `/${this.getId}?with[0]=integrations&with[1]=integrations.countries`;
      try {
        leadApi.getItemClient(url).then((res) => {
          this.$store.commit("lead/setError", {});
          this.$store.commit("lead/setValidationErrors", {});
          const data = res.data;
          this.data = data;
          this.formDataToSend.name = data.name;
          this.formDataToSend.is_active = data.isActive;
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleEditInt(id) {
      this.$router.push({
        path: ROUTE.INTEGRATION_EDIT.replace(":id", id),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-select {
  max-width: 300px;
}
.checkbox-container {
  @include scrollBar;

  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  &_margin {
    margin-top: 20px;
  }
}
.checkbox-container__item {
  padding: 5px 0;
}
.item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr 2fr 1fr;
  padding: 10px 15px;
  margin-bottom: 10px;
  background: gainsboro;
  border-radius: 10px;
}
.item-button {
  padding: 10px;
  border-radius: 10px;
  background: #3c2a1e;
  color: #fff;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
}
.list-items {
  padding-top: 30px;
}
.list-items__title {
  padding: 20px 0;
  font-size: 24px;
  font-weight: 700;
}
</style>
